<template>
	<label class="pt-1 flex-none basis-1/4 font-bold text-gray dark:text-white theme-dark:text-white theme-light:text-gray">
		<slot></slot>
	</label>
</template>
